export default __webpack_public_path__ + "static/media/runtime.c11839fb.png";